import { createContext, useContext } from "react";

/**
 * Zámok tabuľky dielcov (KOLO 231) — prečo prihlásený nesmie meniť
 * zostavy a dielce (obchodník v nábytku mení len cenu v paneli zostavy,
 * rozpočtár tovar len číta). `null` = bez zámku.
 *
 * Bunky, výber, ťahanie a položky menu ho čítajú samy, takže sa nemusí
 * ťahať cez tri typy riadkov. Položka menu je pri zámku **sivá s dôvodom,
 * kým nie je výslovne `citanie`** — nová akcia tak ostane zamknutá sama.
 * Server rovnakú zmenu odmietne tak či tak (403); toto je len aby sa
 * nedala začať.
 */
export const ZamokTabulkyContext = createContext<string | null>(null);

export function useZamokTabulky(): string | null {
  return useContext(ZamokTabulkyContext);
}
